const File = [
  { type: 'item', text: 'Close' },
];

const View = [
  { type: 'item', disable: true, text: 'Sort by: Date' },
  { type: 'item', disable: true, text: 'Sort by: Impact' },
];

const Help = [
  { type: 'item', disable: true, text: 'About experience.log' },
];

export default { File, View, Help };
